/* Variant image filter (INVATI) - shows only the photos of the selected colour.
   Photo alt text must start with the colour name, e.g. "Aqua" or "Aqua - back view".
   Photos with any other alt text stay visible for every colour.
   Desktop: non-matching photos are hidden with CSS.
   Mobile (Flickity slider): non-matching slides are removed from the slider and re-added on change. */
(function () {
  var OPTION_NAMES = ['color', 'colour'];
  var master = null;   // all media wrappers, in original order
  var runId = 0;
  var retries = 0;
  var FlickityClass = null;

  function norm(s) { return (s || '').trim().toLowerCase(); }

  function colorSelect(form) {
    var selects = form.querySelectorAll('select[name^="options["]');
    for (var i = 0; i < selects.length; i++) {
      var name = norm(selects[i].name.slice(8, -1));
      if (OPTION_NAMES.indexOf(name) > -1) return selects[i];
    }
    return null;
  }

  function colorOfAlt(alt, colors) {
    var a = norm(alt), best = null;
    colors.forEach(function (c) {
      if (!c) return;
      if (a === c || a.indexOf(c + ' ') === 0 || a.indexOf(c + '-') === 0 || a.indexOf(c + ':') === 0 || a.indexOf(c + ',') === 0) {
        if (!best || c.length > best.length) best = c;
      }
    });
    return best;
  }

  function colorOfEl(el, colors) {
    var img = el.querySelector('img');
    return img ? colorOfAlt(img.getAttribute('alt'), colors) : null;
  }

  function getFlickity(media) {
    if (FlickityClass) return Promise.resolve(FlickityClass.data(media) || null);
    if (!(window.flu && flu.chunks && flu.chunks.flickity)) return Promise.resolve(null);
    // Built with Function() so Shopify's asset minifier does not rewrite import() into require()
    var dynImport;
    try { dynImport = new Function('u', 'return import(u)'); } catch (e) { return Promise.resolve(null); }
    return dynImport(flu.chunks.flickity).then(function (m) {
      FlickityClass = m.Flickity || m.default;
      return FlickityClass && FlickityClass.data ? (FlickityClass.data(media) || null) : null;
    }).catch(function () { return null; });
  }

  function sameList(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function run() {
    var form = document.querySelector('form.product-form');
    if (!form) return;
    var select = colorSelect(form);
    if (!select) return;
    var section = form.closest('.shopify-section') || document;
    var media = section.querySelector('.product__media');
    if (!media) return;

    var colors = [].map.call(select.options, function (o) { return norm(o.value); });
    var current = norm(select.value);
    if (!master) master = [].slice.call(section.querySelectorAll('.product__media .media-wrapper'));
    if (!master.some(function (el) { return colorOfEl(el, colors); })) return;

    // Thumbnails (desktop): hide with CSS
    section.querySelectorAll('.product-thumbnails__item').forEach(function (el) {
      var c = colorOfEl(el, colors);
      if (c && c !== current) el.setAttribute('data-vf-hide', '');
      else el.removeAttribute('data-vf-hide');
    });

    var matches = master.filter(function (el) {
      var c = colorOfEl(el, colors);
      return !c || c === current;
    });

    var id = ++runId;
    // The theme turns the gallery into a slider on phones (CSS ::after content "flickity")
    var sliderMode = /flickity/.test(window.getComputedStyle(media, ':after').content || '');
    if (sliderMode) master.forEach(function (el) { el.removeAttribute('data-vf-hide'); });
    getFlickity(media).then(function (flkty) {
      if (id !== runId) return;
      if (sliderMode && !(flkty && flkty.isActive)) {
        // Slider not created yet - try again shortly
        if (retries++ < 40) setTimeout(run, 250);
        return;
      }
      retries = 0;
      if (flkty && flkty.isActive) {
        // Mobile slider: rebuild the slides with only the matching photos
        master.forEach(function (el) { el.removeAttribute('data-vf-hide'); });
        var cells = flkty.getCellElements();
        if (!sameList(cells, matches)) {
          flkty.remove(cells);
          flkty.append(matches);
          flkty.select(0, false, true);
        }
      } else {
        // Desktop: make sure every photo is back in the page, then hide with CSS
        if (master.some(function (el) { return !el.isConnected; })) {
          master.forEach(function (el) { media.appendChild(el); });
        }
        master.forEach(function (el) {
          if (matches.indexOf(el) === -1) el.setAttribute('data-vf-hide', '');
          else el.removeAttribute('data-vf-hide');
        });
        var shown = section.querySelector('.product__media .media-wrapper:not(.hidden):not([data-vf-hide])');
        if (!shown) {
          var btn = section.querySelector('.product-thumbnails__item:not([data-vf-hide]) button');
          if (btn) btn.click();
        }
      }
    });
  }

  function later() { setTimeout(run, 80); }

  var style = document.createElement('style');
  style.textContent = '[data-vf-hide]{display:none !important;}';
  document.head.appendChild(style);

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('form.product-form')) later();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-form__color-swatch, .product-form__chip')) later();
  });
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 400);
  });
  // The theme creates the mobile slider a moment after load, so run twice
  function start() { run(); setTimeout(run, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
